import { useState } from "react";
import "./Navbar.styles.scss";
import { Link, useLocation } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import images from "../../../constants/images";
import CloseIcon from "@mui/icons-material/Close";
import useTranslate from "../../../hooks/useTranslate";
import i18next from "i18next";
import LanguageSwitch from "../../LanguageSwitch/LanguageSwitch";

const Navbar = ({ isHomePage }) => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { pathname } = useLocation();
  const overImage =
    isHomePage ||
    pathname === "/" ||
    /^\/projects(?:\/|$)/.test(pathname) ||
    /^\/services\/.+/.test(pathname);

  const { translate, language } = useTranslate();
  const isPersian = language?.startsWith("fa");
  const toggleMenuHandler = () => {
    setToggleMenu((prevState) => !prevState);
  };

  return (
    <div
      className={`app__navbar ${
        overImage ? "app__navbar--over-image" : "app__navbar--on-light"
      }`}
      id="top"
    >
      <div className="logo__container">
        <Link to="/" className="app__navbar-logo">
          <img src={images.logo} alt="app logo" />
        </Link>

        <div className={`logo__container--languages`}>
          <LanguageSwitch />
        </div>
      </div>

      <ul className={`app__navbar-links ${i18next.language}`}>
        <li className="p__openSans">
          <Link to="/">{translate("home.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/projects">{translate("projects.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/services">{translate("services.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/blog">{translate("blog.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/archive">{translate("archive.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/about-us">{translate("aboutUs.navbar")}</Link>
        </li>
        <li className="p__openSans">
          <Link to="/contact-us">{translate("contactUs.navbar")}</Link>
        </li>
      </ul>

      <div className="app__navbar-smallScreen">
        <button
          type="button"
          className="app__navbar-menu-button"
          aria-label={isPersian ? "باز کردن منو" : "Open menu"}
          aria-expanded={toggleMenu}
          aria-controls="navbar-mobile-menu"
          onClick={toggleMenuHandler}
        >
          <GiHamburgerMenu fontSize={27} />
        </button>
        {toggleMenu && (
          <div
            id="navbar-mobile-menu"
            className="app__navbar-smallScreen_overlay flex__center slide-bottom"
          >
            <button
              type="button"
              className="overlay__close"
              aria-label={isPersian ? "بستن منو" : "Close menu"}
              onClick={toggleMenuHandler}
            >
              <CloseIcon fontSize="large" />
            </button>
            <ul className="app__navbar-smallScreen_links">
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/">{translate("home.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/projects">{translate("projects.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/services">{translate("services.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/blog">{translate("blog.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/archive">{translate("archive.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/about-us">{translate("aboutUs.navbar")}</Link>
              </li>
              <li className="p__openSans" onClick={toggleMenuHandler}>
                <Link to="/contact-us">{translate("contactUs.navbar")}</Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
export default Navbar;
